export const DITTO_SHARE_DATA_LOAD = 'dittoShare/DITTO_SHARE_DATA_LOAD';
export const DITTO_SHARE_DATA_SUCCESS = 'dittoShare/DITTO_SHARE_DATA_SUCCESS';
export const DITTO_SHARE_DATA_FAIL = 'dittoShare/DITTO_SHARE_DATA_FAIL';
export const SET_DITTO_SHARE_FROM_STORAGE = 'dittoShare/SET_DITTO_SHARE_FROM_STORAGE';
